import { render, staticRenderFns } from "./DetailContent.vue?vue&type=template&id=3e9733aa&scoped=true"
import script from "./DetailContent.vue?vue&type=script&lang=js"
export * from "./DetailContent.vue?vue&type=script&lang=js"
import style0 from "./DetailContent.vue?vue&type=style&index=0&id=3e9733aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9733aa",
  null
  
)

export default component.exports